<template>
    <a :href="slide.url">
        <div class="card">
            <div class="slider-item" :style="backgroundImage">
                <div class="card__text">
                    <span class="font-italic">{{ slide.category }}</span>
                    <h2 class="font-weight-bold">
                        {{ slide.title }}
                    </h2>
                </div>
                <div class="card__bottom">
                    <div class="card__bottom__button">
                        <span class="card__bottom__button__content"
                            >{{ buttonText
                            }}<span
                                class="icon-angle-right card__bottom__button__content__icon"
                            ></span
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        slide: {
            type: Object,
            default() {
                return [];
            }
        },
        buttonText: {
            type: String,
            default: ''
        }
    },
    computed: {
        backgroundImage() {
            return { backgroundImage: `url(${this.slide.image})` };
        }
    }
};
</script>
